import { FC } from 'react';
import styled from 'styled-components';
import { Alert, Skeleton, Stack } from '@mui/material';
import { useGetAssociateInsights } from '@vs-online-only-app/state';
import InsightsBoxes from './InsightsBoxes';

export const BoxesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

const Insights: FC = () => {
  const { isLoading, data, error } = useGetAssociateInsights();

  if (isLoading) {
    return (
      <Stack>
        <Stack direction="row" justifyContent="space-between">
          <Skeleton height={34} width={100} />
          <Skeleton height={34} width={100} />
        </Stack>
        <BoxesContainer>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              height={111}
              width="100%"
              sx={{ borderRadius: 2 }}
            />
          ))}
        </BoxesContainer>
      </Stack>
    );
  }

  if (!data || error) return <Alert>Could not fetch metrics</Alert>;

  return <InsightsBoxes associateInsights={data} />;
};

export default Insights;
